"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderReviewNotificationUseCase = void 0;
const react_1 = require("react");
const useCustomerOrderToReview_1 = require("../../hooks/useCustomerOrderToReview");
const orderToReview_1 = require("../../services/customer/orderToReview");
function useOrderReviewNotificationUseCase(params) {
    const { customerId, hasReviewed } = params;
    const [showNotification, setShowNotification] = (0, react_1.useState)(false);
    const shouldRequestReview = (0, react_1.useMemo)(() => {
        if (hasReviewed) {
            return false;
        }
        return orderToReview_1.OrderReviewNotificationService.shouldRequestReview();
    }, [hasReviewed]);
    const { orderToReview } = (0, useCustomerOrderToReview_1.useCustomerOrderToReview)(customerId, shouldRequestReview);
    const closeNotification = () => {
        setShowNotification(false);
    };
    const call = (0, react_1.useCallback)(() => {
        if (shouldRequestReview && orderToReview) {
            const TOAST_DELAY = 3000;
            window.setTimeout(() => {
                setShowNotification(true);
            }, TOAST_DELAY);
        }
    }, [shouldRequestReview, orderToReview]);
    const result = {
        orderReviewToast: {
            isOpen: showNotification,
            close: closeNotification,
        },
        orderToReview,
    };
    return [result, call];
}
exports.useOrderReviewNotificationUseCase = useOrderReviewNotificationUseCase;
